import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Stack } from 'react-bootstrap';
import { Link, useNavigate, useParams } from "react-router-dom";
import './MerReceipts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';
import { addressviewhtml } from '../../Utils/Common';


const MerReceipts = () => {
  const [loading, setLoading] = useState(true);
  const { id, store_id, subscription_transaction_id } = useParams();
  const navigate = useNavigate();

  const [inputs, setInputs] = useState({
    user_name: "",
    mobile: "",
    address: "",
    invoice_no: "",
    current_period_start: "",
    current_period_end: "",
    image: "",
    type: 1,
    sub_total: 0,
    discount: 0,
    grand_total: 0,
    tax: 0,
    account_number: "",
    subscription_id: "",
    customers_id: "",
    status: 1,
    stripe_status: "active",
    days_left: "",
    card: "",
    is_resubscribe: 0,

    new_plan_name: "",
    old_plan_name: "",
    old_price: 0,
    is_upgrade_or_downgrade: "",
    credit: 0,
    formattedTaxLine: "Tax",
    stripe_subtotal: 0,
    stripe_subtotal_excluding_tax: 0,
    stripe_total: 0,
    stripe_total_excluding_tax: 0,
    stripe_amount_due: 0,
    stripe_amount_paid: 0,
    stripe_amount_remaining: 0,
    stripe_total_taxes: 0,
    stripe_appliedBalance: 0,
    subscription_plan_id: 0,
    wallet_rem: 0,
    street_name: '',
    area: '',
    city: '',
    state: '',
    zip: '',
    country_id: ''
  });
  const [ord, setOrd] = useState([]);

  useEffect(() => {
    document.title = `Mer Receipts | Blue Faucet`;
    document.getElementById('bodywrap').className = 'usrrcptcpgmain grnbg';
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', store_id);
    formData.append('subscription_transaction_id', subscription_transaction_id);
    formData.append('id', id);
    API.post('backoffice_merchant_subscription_receipts', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInputs({
            user_name: response.data.data.user_name,
            mobile: response.data.data.mobile,
            address: response.data.data.address,
            invoice_no: response.data.data.invoice_no,
            current_period_start: response.data.data.current_period_start,
            current_period_end: response.data.data.current_period_end,
            image: response.data.data.image,
            type: response.data.data.type,
            sub_total: response.data.data.sub_total,
            discount: response.data.data.discount,
            grand_total: response.data.data.grand_total,
            tax: response.data.data.tax,
            account_number: response.data.data.account_number,
            subscription_id: response.data.data.subscription_id,
            customers_id: response.data.data.customers_id,
            status: response.data.data.status,
            stripe_status: response.data.data.stripe_status,
            days_left: response.data.data.days_left,
            card: response.data.data.card,
            is_resubscribe: response.data.data.is_resubscribe,
            is_upgrade_or_downgrade: response.data.data.is_upgrade_or_downgrade,
            credit: response.data.data.credit,
            stripe_subtotal: response.data.data.stripe_subtotal,
            stripe_subtotal_excluding_tax:
              response.data.data.stripe_subtotal_excluding_tax,
            stripe_total: response.data.data.stripe_total,
            stripe_total_excluding_tax:
              response.data.data.stripe_total_excluding_tax,
            stripe_amount_due: response.data.data.stripe_amount_due,
            stripe_amount_paid: response.data.data.stripe_amount_paid,
            stripe_amount_remaining: response.data.data.stripe_amount_remaining,
            stripe_total_taxes: response.data.data.stripe_total_taxes,
            stripe_appliedBalance: response.data.data.stripe_appliedBalance,
            formattedTaxLine: response.data.data.formattedTaxLine,
            new_plan_name: response.data.data.new_plan_name,
            old_plan_name: response.data.data.old_plan_name,
            old_price: response.data.data.old_price,
            subscription_plan_id: response.data.data.subscription_plan_id,
            amount_due: response.data.data.amount_due ?? 0,
            wallet: response.data.data.wallet ?? 0,
            wallet_rem: response.data.data.wallet_rem ?? 0,
            street_name: response.data.data.street_name,
            area: response.data.data.area,
            city: response.data.data.city,
            state: response.data.data.state,
            zip: response.data.data.zip,
            country_id: response.data.data.country_id
          });
          setOrd(response.data.data.invoice_array);
        }
      }).catch(error => {
        setLoading(false);

      });

  }, [id, store_id, subscription_transaction_id]);

  const formatCurrency = (amount) => {
    const value = Number(amount) || 0;
    return value < 0
      ? `-$${Math.abs(value).toFixed(2)}`
      : `$${value.toFixed(2)}`;
  };

  return (
    <>
      <section className="d-flex justify-content-center">
        <div className='col-12 col-md-6 col-lg-5'>
          <header className="receipt-header rec-bg-green">
            <div className="col-md-1 col-1" onClick={() => navigate(-1)}>
              <Link to=''><svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none"><path d="M6.87756 0.514167C6.63045 0.637723 0.150184 7.12652 0.0607126 7.33955C-0.0202375 7.54406 -0.0202375 7.8849 0.0607126 8.08941C0.107578 8.20018 1.11306 9.23123 3.39671 11.5234C6.83496 14.9659 6.86904 15 7.23971 15C7.52516 15 7.72115 14.9148 7.92565 14.7018C8.22815 14.395 8.28354 14.0158 8.08755 13.6366C8.04495 13.5557 6.92869 12.4053 5.60366 11.0803L3.1922 8.6731L11.2744 8.6518L19.3609 8.63049L19.5526 8.52398C19.6549 8.46433 19.7998 8.33226 19.8722 8.23426C19.9872 8.06384 20 8.01698 20 7.71448C20 7.41198 19.9872 7.36511 19.8722 7.19469C19.7998 7.0967 19.6549 6.96462 19.5526 6.90498L19.3609 6.79846L11.2744 6.77716L3.1922 6.75586L5.62497 4.32735C7.26527 2.68704 8.08329 1.84346 8.13868 1.72842C8.34745 1.28533 8.15146 0.744236 7.69985 0.509907C7.48682 0.399133 7.10337 0.403393 6.87756 0.514167Z" fill="white"></path></svg></Link>
            </div>
            <div className="col-md-9 col-7">
              <h5>Subscription Change Receipt</h5>
            </div>
            <div className="col-md-1 col-2">
            </div>
          </header>
          <div className="jikam">
            <Row className="mx-0 mianhmdwncnt">
              <Col className="mnhmcnt p-0">
                <Col md={12} xs={12}>
                  <Row className="mx-0 maincnt-recepts">
                    <div className="mrrec-one">
                      <div className="d-flex align-items-start justify-content-between gap-3">
                        <div>
                          <h3>BlueFaucet inc.</h3>
                          <p>522 W,Riverside Ave. #5689</p>
                          <p>Spokane, WA 99201</p>
                        </div>
                        <div className="text-end left-cnt-rcpt mrrec-two">
                          <img src={inputs.image} className="img-fluid" alt="Hm Img" />
                          {/* <h4>Due Date:<span>20May 2023</span></h4> */}
                        </div>
                      </div>
                      <div className="left-cnt-rcptr">
                        <h4>Customer Name: {inputs.user_name}</h4>
                        <h4>Merchant ID #:{inputs.customers_id}</h4>
                        <h4>Phone number: {inputs.mobile}</h4>

                        {inputs.street_name !== '' ?
                          <>
                            <h4>Customer address:</h4><span>{addressviewhtml(inputs.street_name, inputs.area, inputs.city, inputs.state, inputs.zip, inputs.country_id)}</span>
                          </>
                          : null}
                      </div>

                      <div className="dwncmt">
                        {/* <h4>Serviced by: <span>xxxxxxxxxxxx</span></h4> */}
                        <h5>Information:</h5>
                        <h4>Receipt No.{inputs.invoice_no}</h4>

                        <h4>Receipt Date: {inputs.current_period_start}</h4>

                        <h4>Next Billing Date : {inputs.current_period_end}</h4>

                      </div>
                    </div>
                    
                    <Col md={12} xs={12} className="tblinvcpg mrrec-thr">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Service/Items</th>

                            <th className="text-end">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ord && ord.map((val, index) => {
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{val.name}</td>
                                <td className="text-end">{formatCurrency(val.amount)}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </Table>
                      <Row className='g-3'>
                        <Col lg={6} className='order-2 order-lg-1'>
                          <div className="text-start tbldwndv">
                            <p>Your subscription update is complete.</p>
                            <p>Your existing credit has been applied to cover the cost of your new {inputs.new_plan_name} plan.</p>

                            {
                              inputs.amount_due === 0 && inputs.wallet_rem > 0 ?
                                <p> The remaining balance of {formatCurrency(inputs.wallet_rem)} has been
                                  deposited back into your Account Wallet and will be automatically
                                  applied to future invoices.
                                </p>
                                : <></>
                            }

                            <p><b>Important Notice:</b> Your new plan tiers affect
                              your complimentary employee account limits. Please
                              check the Employee Management page for updated
                              details.
                            </p>
                            {(() => {
                              if (
                                inputs.status === 1 &&
                                inputs.stripe_status === "trialing"
                              ) {
                                return (
                                  <>
                                    <p>Thank you for your order!</p>
                                    <p>
                                      You still have <b>{inputs.days_left}</b>{" "}
                                      days remaining in your free trial, so no
                                      charges will apply until your end of Free
                                      Trial Date. In the meantime, you can start
                                      enjoying all the benefits of your
                                      subscription right away.
                                    </p>
                                  </>
                                );
                              } else if (
                                inputs.status === 2 &&
                                inputs.is_resubscribe === 0
                              ) {
                                return <></>;
                              } else if (inputs.is_resubscribe === 1) {
                                return (
                                  <>
                                    <p>
                                      Welcome back! Your subscription has been
                                      successfully reactivated.
                                    </p>
                                  </>
                                );
                              } else {

                                return inputs.amount_due > 0 ? (
                                  <>
                                    {inputs.card && <p>Card:- {inputs.card}</p>}

                                    {inputs.subscription_id && (
                                      <p>Transaction Number:- {inputs.subscription_id}</p>
                                    )}
                                  </>
                                ) : null;
                              }
                            })()}
                          </div>
                        </Col>
                        <Col lg={6} className='order-1 order-lg-2'>
                          <div className="text-end tbldwndv">
                            <Stack direction="horizontal" gap={0}>
                              <div className="pb-1 ms-auto">
                                <p>Total Amount (Taxable Amount)</p>
                              </div>
                              <div className="pb-1">
                                <span>
                                  {" "}
                                  {formatCurrency(inputs.stripe_subtotal)}
                                </span>
                              </div>
                            </Stack>

                            <Stack
                              className="d-none"
                              direction="horizontal"
                              gap={0}
                            >
                              <div className="pb-1 ms-auto">
                                <p>Total excluding tax</p>
                              </div>
                              <div className="pb-1">
                                <span>${inputs.stripe_total_excluding_tax}</span>
                              </div>
                            </Stack>
                            <Stack direction="horizontal" gap={0}>
                              <div className="pb-1 ms-auto">
                                <p>{inputs.formattedTaxLine}</p>
                              </div>
                              <div className="pb-1">
                                <span>
                                  {formatCurrency(inputs.stripe_total_taxes)}
                                </span>
                              </div>
                            </Stack>
                            <Stack
                              direction="horizontal"
                              className="d-none"
                              gap={0}
                            >
                              <div className="pb-1 ms-auto">
                                <p>Total</p>
                              </div>
                              <div className="pb-1">
                                <span>{formatCurrency(inputs.stripe_total)}</span>
                              </div>
                            </Stack>
                            <Stack direction="horizontal" gap={0}>
                              <div className="pb-1 ms-auto">
                                <p>Less: Wallet Balance Applied</p>
                              </div>
                              <div className="pb-1">
                                <span>{formatCurrency(inputs.wallet)}</span>
                              </div>
                            </Stack>
                            <Stack direction="horizontal" gap={0}>
                              <div className="pb-1 ms-auto">

                                <p>{inputs.amount_due > 0 ? 'Amount Paid' : 'Amount Due'}</p>
                              </div>
                              <div className="pb-1">
                                <span>{formatCurrency(inputs.amount_due)}</span>
                              </div>
                            </Stack>

                            <Stack direction="horizontal" gap={0}>
                              <div className="pb-1 ms-auto">
                                <p>Remaining Balance</p>
                              </div>
                              <div className="pb-1">
                                <span>{formatCurrency(inputs.wallet_rem)}</span>
                              </div>
                            </Stack>

                            <Stack
                              direction="horizontal"
                              className="d-none"
                              gap={0}
                            >
                              <div className="pb-1 ms-auto">
                                {(() => {
                                  if (inputs.credit > 0) {
                                    return (
                                      <>
                                        <p>Credit to Wallet</p>
                                      </>
                                    );
                                  }
                                })()}

                                {(() => {
                                  if (inputs.stripe_amount_paid > 0) {
                                    return (
                                      <>
                                        <p>Debit from Wallet</p>
                                      </>
                                    );
                                  }
                                })()}
                              </div>
                              <div className="pb-1">
                                <span>
                                  {formatCurrency(inputs.stripe_appliedBalance)}
                                </span>
                              </div>
                            </Stack>

                            <Stack
                              direction="horizontal"
                              className="d-none"
                              gap={0}
                            >
                              <div className="pb-1 ms-auto">
                                <p>Total Due</p>
                              </div>
                              <div className="pb-1">
                                <span>
                                  {formatCurrency(inputs.stripe_amount_paid)}
                                </span>
                              </div>
                            </Stack>

                            <Stack
                              className="d-none"
                              direction="horizontal"
                              gap={0}
                            >
                              <div className="pb-1 ms-auto">
                                <p>Amount remaining</p>
                              </div>
                              <div className="pb-1">
                                <span>${inputs.stripe_amount_remaining}</span>
                              </div>
                            </Stack>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12} xs={12} className="dwn-cntrecpt mrrec-fou">
                      {(() => {
                        if (
                          inputs.status === 2 &&
                          (inputs.stripe_status === "canceled" ||
                            inputs.stripe_status === "active")
                        ) {
                          return (
                            <>
                              <h3>Cancellation Information:</h3>
                              <p>
                                <b>Your cancellation is confirmed.</b> We’ll be
                                sad to see you leave! To avoid any interruption in
                                your growth, you can click <b>"Re-Subscribe"</b>{" "}
                                at any time before your current term ends.
                              </p>
                              <p>
                                {" "}
                                If there's anything we can do to improve your
                                experience, please reach out to{" "}
                                <b>cs@bluefaucet.com."</b>
                              </p>
                            </>
                          );
                        } else {
                          return (
                            <>
                              <h3>Recurring Information:</h3>

                              {inputs.status === 2 ? (
                                <p>{"Your recurring charge is disabled."}</p>
                              ) : (
                                <p>
                                  {inputs.type === 0
                                    ? "Your recurring charge is disabled. Please enable it to save you time"
                                    : "Your recurring charge is enabled."}
                                </p>
                              )}

                              <p>
                                Contact us at CS@bluefaucet.com if you have any
                                question about{" "}
                                {inputs.status === 2
                                  ? "cancellation confirmation."
                                  : "the receipt."}{" "}
                              </p>
                            </>
                          );
                        }
                      })()}
                    </Col>
                  </Row>
                </Col>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  )
}
export default MerReceipts;